import React from 'react';

const Sidebar = ({ isOpen, onClose, currentPage, onNavigate, userRole }) => {
  // Menu for dental users
  const dentalMenuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: 'fas fa-chart-line' },
    { id: 'scheduling', label: 'SAI Smart Scheduling', icon: 'fas fa-calendar-alt' },
    { id: 'patients', label: 'PatientsNow', icon: 'fas fa-users' },
    { id: 'insurance', label: 'Insurance', icon: 'fas fa-hospital' },
    { id: 'treatment', label: 'Treatment Plans', icon: 'fas fa-clipboard-list' },
    { id: 'forecasting', label: 'Forecasting', icon: 'fas fa-chart-line' },
    { id: 'payments', label: 'Payments (RCM)', icon: 'fas fa-dollar-sign' },
    { id: 'fee-optimization', label: 'Fee Optimization', icon: 'fas fa-coins' },
    { id: 'selfdrivingpractice', label: 'Selft-Driving Practice', icon: 'fas fa-coins' },
    { id: 'dentallm', label: 'DentalLLM', icon: 'fas fa-robot' },
    { id: 'logout', label: 'Log Out', icon: 'fas fa-sign-out' },
  ];

  // Menu for DSO users
  const dsoMenuItems = [
    { id: 'control-tower', label: 'Control Tower', icon: 'fas fa-tower-broadcast' },
    { id: 'targets-policies', label: 'Targets & Policies', icon: 'fas fa-bullseye' },
    { id: 'optimization-runs', label: 'Optimization Runs', icon: 'fas fa-cogs' },
    { id: 'open-slot-marketplace', label: 'Open-Slot Marketplace', icon: 'fas fa-store' },
    { id: 'float-pool-planner', label: 'Float Pool Planner', icon: 'fas fa-swimming-pool' },
    { id: 'work-queue', label: 'Work Queue', icon: 'fas fa-tasks' },
    { id: 'scenario-planning', label: 'Scenario Planning', icon: 'fas fa-project-diagram' },
    { id: 'templates-playbooks', label: 'Templates & Playbooks', icon: 'fas fa-book' },
      { id: 'explainability', label: 'Explainability', icon: 'fas fa-lightbulb' },
      { id: 'logout', label: 'Log Out', icon: 'fas fa-sign-out' },
    ];


    const vetMenuItems = [
        { id: 'vet-dashboard', label: 'Dashboard', icon: 'fas fa-chart-line' },
        { id: 'scheduling', label: 'Smart Scheduling', icon: 'fas fa-calendar-alt' },
        { id: 'patients', label: 'PatientsNow', icon: 'fas fa-users' },
        { id: 'preventivecare', label: 'Preventive Care', icon: 'fas fa-users' },
        { id: 'careplans', label: 'Care Plans', icon: 'fas fa-users' },
        { id: 'insurance', label: 'Pet Insurance', icon: 'fas fa-hospital' },       
        { id: 'fee-optimization', label: 'Fee Optimization', icon: 'fas fa-coins' },
        { id: 'payments', label: 'Payments (RCM)', icon: 'fas fa-dollar-sign' },       
        { id: 'selfdrivingpractice', label: 'Self-Driving Practice', icon: 'fas fa-robot' },
      /*  { id: 'settings', label: 'Settings', icon: 'fas fa-gear' },*/
        { id: 'logout', label: 'Log Out', icon: 'fas fa-sign-out' },
    ];

    // Select menu based on user role
    const menuItems = userRole === 'dso' ? dsoMenuItems : userRole === 'vet' ? vetMenuItems : dentalMenuItems;
  
  const handleNavClick = (itemId) => {
    onNavigate(itemId);
    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 1024) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay for mobile/tablet */}
      <div 
        className={`sidebar-overlay ${isOpen ? 'visible' : ''}`} 
        onClick={onClose}
        aria-hidden="true"
      />
      <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>Menu</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close menu">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <button
              key={item.id}
              className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              <span className="nav-icon"><i className={item.icon}></i></span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
